/**
 * Laravel Echo Configuration for real-time broadcasting in QBank frontend
 * Uses Laravel Reverb WebSocket server
 */

import { boot } from "quasar/wrappers";
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

export default boot(({ app }) => {
  // Make Pusher available globally (required by Laravel Echo)
  window.Pusher = Pusher;

  // Determine the API host based on current environment
  const hostname = window.location.hostname;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

  // Reverb configuration - auto-detect based on environment
  const reverbHost = isLocalhost ? '127.0.0.1' : hostname;
  const reverbPort = isLocalhost ? 6001 : 443;
  const reverbScheme = isLocalhost ? 'http' : 'https';
  // Use different keys for local vs production
  const reverbKey = isLocalhost ? '93e3zo2xndp4kn7i4cgy' : 'medpass-reverb-key-7x9k2m4p';

  // Auth endpoint - use proxy in dev mode (relative path goes through Quasar devServer proxy)
  // In production, use the same origin
  const authEndpoint = '/broadcasting/auth';

  console.log('[Echo Boot] Configuration:', {
    reverbHost,
    reverbPort,
    reverbScheme,
    authEndpoint,
    isLocalhost,
  });

  // Helper function to get CSRF token
  // Note: Avoiding optional chaining (?.) for Safari 12/iOS 12 compatibility
  const getCsrfToken = () => {
    // Try meta tag first
    const metaEl = document.querySelector('meta[name="csrf-token"]');
    const metaToken = metaEl ? metaEl.getAttribute('content') : null;
    if (metaToken) return metaToken;

    // Try XSRF-TOKEN cookie
    const match = document.cookie.match(/XSRF-TOKEN=([^;]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  try {
    window.Echo = new Echo({
      broadcaster: 'reverb',
      key: reverbKey,
      wsHost: reverbHost,
      wsPort: reverbPort,
      wssPort: reverbPort,
      forceTLS: reverbScheme === 'https',
      enabledTransports: ['ws', 'wss'],
      // Custom authorizer to handle CORS and credentials
      authorizer: (channel, options) => {
        return {
          authorize: (socketId, callback) => {
            const csrfToken = getCsrfToken();
            console.log('[Echo] Authorizing channel:', channel.name, 'socketId:', socketId);

            fetch(authEndpoint, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-XSRF-TOKEN': csrfToken,
              },
              credentials: 'include', // Important: send cookies for session auth
              body: JSON.stringify({
                socket_id: socketId,
                channel_name: channel.name,
              }),
            })
              .then(response => {
                console.log('[Echo] Auth response status:', response.status);
                if (!response.ok) {
                  throw new Error(`Auth failed with status ${response.status}`);
                }
                return response.json();
              })
              .then(data => {
                console.log('[Echo] Channel auth SUCCESS:', channel.name, data);
                callback(null, data);
              })
              .catch(error => {
                console.error('[Echo] Channel auth ERROR:', channel.name, error);
                callback(error);
              });
          },
        };
      },
    });

    console.log('[Echo Boot] Laravel Echo initialized successfully');
    console.log('[Echo Boot] WebSocket URL:', `${reverbScheme}://${reverbHost}:${reverbPort}`);

    // Add connection state listeners for debugging
    window.Echo.connector.pusher.connection.bind('state_change', (states) => {
      console.log('[Echo] Connection state changed:', states.previous, '->', states.current);
    });

    window.Echo.connector.pusher.connection.bind('connected', () => {
      console.log('[Echo] Connected to WebSocket server!');
    });

    window.Echo.connector.pusher.connection.bind('error', (error) => {
      console.error('[Echo] Connection error:', error);
    });

  } catch (error) {
    console.error('[Echo Boot] Failed to initialize Laravel Echo:', error);
  }
});

export { };
